import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { AuthService } from 'src/app/services/auth.service';
import { RoleGuardService } from 'src/app/services/role-guard.service';
import { Router, RouterStateSnapshot } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  modulos = [];
  modulosCustom = [];
  user;
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    private authService: AuthService,
    private roleGuard: RoleGuardService,
    private router: Router,
    public dialog: MatDialog,
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => {
      changeDetectorRef.detectChanges()
    };
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  private _mobileQueryListener: () => void;
  version = '1.0.4';
  mobileQuery: MediaQueryList;
  @ViewChild('snav') snav;
  ngOnInit(): void {
    this.obtenerUsuario();
    this.getModules();
  }

  visible(modulo: string): any{
    return this.roleGuard.canVisible(modulo);
  }
  cerrarSideNav(): void{


    if(this.mobileQuery.matches){
      this.snav.toggle();
    }

  }

  nav(modulo): void{
    if(modulo.link){
      modulo.link();
      return;
    }
    this.router.navigate([modulo.route]);
  }

 mappModules = (item) => {
    return {icono: item.icon, nombre: item.description, route: item.route};
 }

  getModules(): void{
    const moduleHelp = {icono: 'menu_book', nombre: 'Manual', route: '', link: this.descargarManual}
    const modules = JSON.parse(localStorage.getItem('userPrestador')).profile?.permissions?.map(x => this.mappModules(x));
    modules.push(moduleHelp);
    this.modulos = modules;
  }

  obtenerUsuario(): void{
    const user = JSON.parse(localStorage.getItem('userPrestador'));
    this.user = user;
  }

  descargarManual(): void{
    //const url = 'https:///staticfile/normas-operativas-v1.0.pdf';
    //window.open(url, '_blank');
  }

}
